import { render, staticRenderFns } from "./wx.vue?vue&type=template&id=62f424a0&"
import script from "./wx.vue?vue&type=script&lang=js&"
export * from "./wx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports